<template>
  <b-modal
    v-model="internalVisible"
    hide-header
    hide-footer
    centered
    size="sm"
    body-class="p-[24px] text-center"
  >
    <div class="flex flex-col items-center justify-center">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="warning"
        class="w-[98px] h-[92px] mb-2"
        @error="$event.target.src='https://storage.googleapis.com/komerce/assets/svg/warning-circle.svg'"
      >
      <h4 class="text-[18px] font-semibold text-black mb-[8px]">
        {{ title }}
      </h4>
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="message"
        class="text-[14px] text-[#828282] mb-[24px]"
        v-html="message"
      />
      <!-- eslint-enable vue/no-v-html -->
      <slot v-else />
      <div class="flex justify-center gap-[12px] w-full">
        <b-button
          variant="outline-secondary"
          class="flex-1 rounded-[8px] text-[14px] font-semibold"
          :disabled="loading"
          @click="internalVisible = false"
        >
          {{ cancelText }}
        </b-button>
        <b-button
          :variant="confirmVariant"
          class="flex-1 rounded-[8px] text-[14px] font-semibold text-white border-none"
          :disabled="loading"
          @click="handleConfirm"
        >
          <b-spinner
            v-if="loading"
            small
          />
          <span v-else>{{ confirmText }}</span>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalConfirmation',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Apa Kamu Yakin?',
    },
    message: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'Lanjut',
    },
    cancelText: {
      type: String,
      default: 'Batal',
    },
    confirmVariant: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>
